export default "__VITE_ASSET__C8uNBVOm__"